import { isAfter, isSameDay } from "date-fns";
import { parseTime } from "./format";

export const isTwoDayTimeRange = (startTime: string | Date, endTime: string | Date) => {
  const startTimeDate = typeof startTime === "string" ? parseTime(startTime) : startTime;
  const endTimeDate = typeof endTime === "string" ? parseTime(endTime) : endTime;

  if (!isSameDay(startTimeDate, endTimeDate)) return true;
  return isAfter(startTimeDate, endTimeDate);
};
